module.exports = __webpack_public_path__ + "img/Mampf.48b8381a.jpg";